<!-- eslint-disable -->
<template lang="pug">
    div
        battle-rating-preview(
            v-for="(student, index) in modifiedItems"
            :student="student"
            :battle-rating="student.battleRating"
            :key="index"
        )
</template>

<script>
    /*eslint-disable*/
    import BattleRatingPreview from './Preview.vue';
    export default {
        props: ['items', 'index', 'perPage'],
        computed: {
            modifiedItems () {
                let page = this.$route.query.page;
                return this.items.map((item, index) => {
                    item.computedPosition = index + 1 + (page ? page - 1 : 0) * this.perPage;
                    return item;
                });
            }
        },
        components: {
            BattleRatingPreview
        },
    }
</script>
